export default "__VITE_ASSET__CXifM0zZ__"